
import Layout from '../components/Layout';
import { Bot, Sparkles, MessageCircle, Brain, Crown } from 'lucide-react';
import { Button } from '@/components/ui/button';

const AiFeatures = () => {
  const aiFeatures = [
    {
      icon: <MessageCircle className="h-8 w-8 text-fembot-pink" />,
      title: "AI Conversations",
      description: "Engage with an intelligent AI that can participate in conversations and respond to questions in a natural way.",
      premium: true
    },
    {
      icon: <Brain className="h-8 w-8 text-fembot-pink" />,
      title: "Smart Responses",
      description: "Get intelligent responses to questions about server rules, commands, and other information.",
      premium: true
    },
    {
      icon: <Bot className="h-8 w-8 text-fembot-pink" />,
      title: "Custom Personality",
      description: "Premium users can customize the AI's personality and conversation style to match their server's theme.",
      premium: true
    },
    {
      icon: <Sparkles className="h-8 w-8 text-fembot-pink" />,
      title: "Content Assistance",
      description: "Get help generating ideas, content suggestions, and creative writing assistance for your server.",
      premium: true
    }
  ];

  return (
    <Layout>
      <div className="py-24 bg-gradient-to-b from-white to-pink-50 dark:from-gray-800 dark:to-gray-900">
        <div className="container-custom">
          <div className="text-center mb-16">
            <div className="inline-block p-3 rounded-full bg-fembot-pink/10 mb-4">
              <Bot className="h-10 w-10 text-fembot-pink" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4 dark:text-white">
              AI <span className="text-fembot-pink">Capabilities</span>
            </h1>
            <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
              Enhance your Discord server with advanced AI conversation features
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {aiFeatures.map((feature, index) => (
              <div key={index} className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-lg transition-all hover:shadow-xl hover:-translate-y-1 duration-300 relative">
                {feature.premium && (
                  <div className="absolute -top-3 -right-3">
                    <div className="inline-block p-1.5 rounded-full bg-gradient-to-r from-yellow-400 to-amber-600">
                      <div className="bg-white dark:bg-gray-800 rounded-full px-3 py-1">
                        <div className="flex items-center space-x-1 rounded-full text-xs font-semibold text-amber-700 dark:text-amber-400">
                          <Crown className="h-3 w-3" />
                          <span>Premium</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="bg-fembot-pink/10 rounded-full p-3 w-16 h-16 flex items-center justify-center mb-4">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-bold mb-2 dark:text-white">{feature.title}</h3>
                <p className="text-gray-600 dark:text-gray-400 mb-4">{feature.description}</p>
              </div>
            ))}
          </div>

          <div className="mt-16 bg-white dark:bg-gray-800 rounded-xl p-8 shadow-xl">
            <div className="flex flex-col text-center">
              <h3 className="text-2xl font-bold mb-4 dark:text-white">Unlock AI Features with Premium</h3>
              <p className="text-gray-600 dark:text-gray-400 mb-8 max-w-2xl mx-auto">
                All AI features are exclusive to Premium users. Plus users receive 50 AI interactions per day, while Pro users enjoy unlimited AI interactions.
              </p>
              <Button 
                className="bg-gradient-to-r from-fembot-pink to-fembot-dark-pink hover:from-fembot-dark-pink hover:to-fembot-pink text-white px-6 py-3 mx-auto"
                onClick={() => window.location.href = '/premium'}
              >
                <Sparkles className="mr-2 h-5 w-5" />
                Upgrade to Premium
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AiFeatures;
